import 'react-app-polyfill/stable';
import { render } from 'react-dom';
import * as Sentry from '@sentry/browser';
import '@spotify-internal/encore-web/css/encore-creator-light-theme.css';
import GlobalStyles from 'app/GlobalStyles';
import { BrowserRouter } from 'react-router-dom';
import App from 'app/App';
import { queryCache } from 'init';
import { ReactQueryCacheProvider } from 'react-query';
import 'moment/min/locales';
import { i18nFactory, I18nWrapper } from './i18n/components/I18nWrapper';
import { LanguageSelection } from './i18n/components/LanguageSelection';
import '@spotify-internal/css-physical-to-logical/css/styles.css';
import { StyleSheetManager, StylisPlugin } from 'styled-components';
import { stylisPhysicalToLogical } from '@spotify-internal/css-physical-to-logical';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://5a8ddf686a674ae5bf6785e93915f70b@sentry.io/1259625',
    release: document.body.dataset.version,
  });
}

const i18n = i18nFactory();

const stylisPlugins: StylisPlugin[] = [stylisPhysicalToLogical as any];

export function appWithCssTransform(WrappedApp: React.ComponentType) {
  function AppWithCssTransform(props: any) {
    return (
      <StyleSheetManager stylisPlugins={stylisPlugins}>
        <WrappedApp {...props} />
      </StyleSheetManager>
    );
  }
  return AppWithCssTransform;
}

const AppWithCssTransform = appWithCssTransform(App);

render(
  <div className="encore-creator-light-theme">
    <GlobalStyles />
    <ReactQueryCacheProvider queryCache={queryCache}>
      <BrowserRouter>
        <I18nWrapper i18n={i18n}>
          <LanguageSelection>
            <div style={{ display: 'contents' }} dir="ltr">
              <AppWithCssTransform />
            </div>
          </LanguageSelection>
        </I18nWrapper>
      </BrowserRouter>
    </ReactQueryCacheProvider>
  </div>,
  document.getElementById('root'),
);
